/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamStudentSupervisorFaceResponseDisplayName } from './oralExamStudentSupervisorFaceResponseDisplayName';
import type { OralExamStudentSupervisorFaceResponsePhotoBlobPath } from './oralExamStudentSupervisorFaceResponsePhotoBlobPath';

/**
 * One supervisor face in the student exam frame (no observing visits).
 */
export interface OralExamStudentSupervisorFaceResponse {
  lecturerId: string;
  displayName?: OralExamStudentSupervisorFaceResponseDisplayName;
  photoBlobPath?: OralExamStudentSupervisorFaceResponsePhotoBlobPath;
}
